/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type CreditLedgerExportStatusResponseStatus = typeof CreditLedgerExportStatusResponseStatus[keyof typeof CreditLedgerExportStatusResponseStatus];


export const CreditLedgerExportStatusResponseStatus = {
  pending: 'pending',
  processing: 'processing',
  ready: 'ready',
  failed: 'failed',
} as const;
